/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  disabled: Boolean,
  inputNumberProps: {
    type: [Boolean, Object],
    "default": false
  },
  label: {
    type: [String, Boolean, Function],
    "default": false
  },
  layout: {
    type: String,
    "default": "horizontal",
    validator: function validator(val) {
      return ["vertical", "horizontal"].includes(val);
    }
  },
  marks: {
    type: [Object, Array]
  },
  max: {
    type: Number,
    "default": 100
  },
  min: {
    type: Number,
    "default": 0
  },
  range: Boolean,
  step: {
    type: Number,
    "default": 1
  },
  showStep: {
    type: Boolean,
    "default": false
  },
  modelValue: {
    type: [Number, Array],
    "default": void 0
  },
  tooltipProps: {
    type: Object
  },
  value: {
    type: [Number, Array],
    "default": void 0
  },
  defaultValue: {
    type: [Number, Array]
  },
  onChange: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
